import React from "react";
import { LoginWrapper } from "shared";
import "./termsOfServiceSuccessionPage.scss";

type termsOfServiceSuccessionPage = {};

const TermsOfServicePage: React.FC<termsOfServiceSuccessionPage> = () => {
  return (
    <LoginWrapper className="terms-of-service-succesion-page">
      <>
        <p className="login-wrapper__subtitle">
          <div className="rodo-container">
            <h1 className="login-wrapper__header">
              Regulamin usługi „SUKCESJA" <br /> w aplikacji app.reliance.pro
            </h1>
            {/* § 1 */}
            <h2>§ 1. Postanowienia ogólne</h2>
            <ol className="numeric indentation--big">
              <li>
                Niniejszy Regulamin określa zasady korzystania z usługi
                „Sukcesja", dostępnej w ramach aplikacji internetowej
                app.reliance.pro, prowadzonej przez{" "}
                <strong>Reliance Holding sp. z o.o.</strong> z siedzibą w{" "}
                <strong>Krakowie (31-425) przy al. 29 Listopada 39E/LU3</strong>
                , wpisaną do KRS: 0000686682, NIP: 6751598679, REGON: 367804850,
                adres e-mail:{" "}
                <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>,
                zwaną dalej „Reliance Holding".
              </li>
              <li>
                Usługa „Sukcesja" stanowi usługę świadczoną drogą elektroniczną
                i ma charakter dodatkowy względem podstawowego konta Użytkownika
                w aplikacji.
              </li>
              <li>
                Regulamin określa w szczególności:
                <ol className="numeric indentation--big">
                  <li>rodzaj i zakres usługi „Sukcesja";</li>
                  <li>zasady aktywacji i korzystania z usługi;</li>
                  <li>zasady dodawania osób wskazanych przez Użytkownika;</li>
                  <li>
                    zasady udostępnienia materiałów po śmierci Użytkownika;
                  </li>
                  <li>
                    opłaty, zasady reklamacji oraz odpowiedzialność stron.
                  </li>
                </ol>
              </li>
              <li>
                W zakresie nieuregulowanym w niniejszym Regulaminie zastosowanie
                mają postanowienia głównego regulaminu aplikacji
                app.reliance.pro oraz właściwe przepisy prawa polskiego.
              </li>
            </ol>

            {/* § 2 */}
            <h2>§ 2. Definicje</h2>
            <p className="indentation--big">
              Na potrzeby niniejszego Regulaminu przyjmuje się następujące
              definicje:
            </p>
            <ol className="numeric indentation--big">
              <li>
                <strong>Aplikacja</strong> – serwis internetowy dostępny pod
                adresem app.reliance.pro.
              </li>
              <li>
                <strong>Użytkownik</strong> – osoba fizyczna posiadająca aktywne
                konto w Aplikacji i korzystająca z usługi „Sukcesja".
              </li>
              <li>
                <strong>Usługa „Sukcesja"</strong> – funkcjonalność
                umożliwiająca przechowywanie przez Użytkownika określonych
                informacji i plików w celu ich udostępnienia po śmierci
                Użytkownika na zasadach opisanych w Regulaminie.
              </li>
              <li>
                <strong>Materiały Sukcesyjne</strong> – dokumenty, notatki,
                pliki, zdjęcia i inne treści zapisane przez Użytkownika w
                zakładce „Sukcesja".
              </li>
              <li>
                <strong>Osoba Wskazana</strong> – osoba dodana przez Użytkownika
                w ramach usługi „Sukcesja", która może zostać poinformowana o
                procedurze dostępu do Materiałów Sukcesyjnych lub której może
                zostać przyznany dostęp do tych materiałów po śmierci
                Użytkownika, zgodnie z dyspozycją Użytkownika.
              </li>
              <li>
                <strong>Wniosek Dostępowy</strong> – zgłoszenie złożone do
                Reliance Holding po śmierci Użytkownika w celu uzyskania dostępu
                do Materiałów Sukcesyjnych.
              </li>
              <li>
                <strong>Usługa Powiadomienia</strong> – dodatkowa usługa
                polegająca na poinformowaniu Osoby Wskazanej o procedurze
                ubiegania się o dostęp do Materiałów Sukcesyjnych po śmierci
                Użytkownika.
              </li>
              <li>
                <strong>Karta Sukcesyjna</strong> – spersonalizowany dokument
                fizyczny wydawany przez Reliance Holding Osobie Wskazanej po
                złożeniu zamówienia przez Użytkownika, potwierdzający
                uprawnienie do złożenia Wniosku Dostępowego. Karta Sukcesyjna
                zawiera dane identyfikacyjne Osoby Wskazanej, unikalny numer
                karty oraz pouczenie o procedurze składania Wniosku Dostępowego.
              </li>
              <li>
                <strong>Punkt Obsługi</strong> – stacjonarne miejsce obsługi
                Reliance Holding, w którym Osoba Wskazana może złożyć Wniosek
                Dostępowy oraz przejść weryfikację tożsamości. Lista Punktów
                Obsługi oraz ich godziny otwarcia są publikowane w Aplikacji i
                na stronie internetowej Reliance Holding.
              </li>
            </ol>

            {/* § 3 */}
            <h2>§ 3. Zakres usługi „Sukcesja"</h2>
            <ol className="numeric indentation--big">
              <li>
                W ramach usługi „Sukcesja" Użytkownik może:
                <ol className="numeric indentation--big">
                  <li>
                    dodawać i przechowywać Materiały Sukcesyjne, w szczególności
                    dokumenty, notatki prywatne, zdjęcia oraz inne pliki;
                  </li>
                  <li>
                    oznaczać, czy określone Materiały Sukcesyjne mogą być
                    widoczne dla upoważnionych pracowników lub współpracowników
                    Reliance Holding;
                  </li>
                  <li>dodawać, edytować i usuwać Osoby Wskazane;</li>
                  <li>
                    zlecić Reliance Holding poinformowanie Osoby Wskazanej o
                    procedurze dostępu do Materiałów Sukcesyjnych po śmierci
                    Użytkownika;
                  </li>
                  <li>
                    zarządzać zakresem i treścią pozostawionych informacji.
                  </li>
                </ol>
              </li>
              <li>
                Usługa „Sukcesja" służy wyłącznie do przechowywania informacji
                wskazanych przez Użytkownika i ich późniejszego udostępnienia
                zgodnie z jego dyspozycją, po spełnieniu warunków określonych w
                Regulaminie.
              </li>
              <li>
                Usługa „Sukcesja":
                <ol className="numeric indentation--big">
                  <li>nie stanowi depozytu notarialnego;</li>
                  <li>
                    nie zastępuje testamentu, postępowania spadkowego ani innych
                    czynności prawnych wymaganych przez przepisy prawa;
                  </li>
                  <li>
                    nie stanowi usługi doradztwa prawnego, podatkowego ani
                    spadkowego.
                  </li>
                </ol>
              </li>
              <li>
                Reliance Holding nie weryfikuje merytorycznej poprawności,
                ważności prawnej ani skuteczności dokumentów i informacji
                zamieszczanych przez Użytkownika w zakładce „Sukcesja", chyba że
                wyraźnie wskazano inaczej w odrębnej umowie.
              </li>
            </ol>

            {/* § 4 */}
            <h2>§ 4. Aktywacja usługi i opłaty</h2>
            <ol className="numeric indentation--big">
              <li>
                Aktywacja usługi „Sukcesja" następuje po uruchomieniu tej
                funkcjonalności w Aplikacji oraz zaakceptowaniu niniejszego
                Regulaminu.
              </li>
              <li>
                Dodanie pierwszej Osoby Wskazanej wiąże się z jednorazową opłatą
                w wysokości <strong>199,00 zł brutto</strong>. Opłata obejmuje
                aktywację funkcjonalności Sukcesji dla tej Osoby Wskazanej oraz
                wydanie i wysyłkę Karty Sukcesyjnej.
              </li>
              <li>
                Dodanie każdej kolejnej Osoby Wskazanej wiąże się z opłatą w
                wysokości <strong>99,00 zł brutto</strong> za każdą taką osobę,
                obejmującą również wydanie i wysyłkę Karty Sukcesyjnej.
              </li>
              <li>
                Opłaty, o których mowa powyżej, są pobierane z góry, zgodnie z
                aktualnie udostępnioną w Aplikacji metodą płatności.
              </li>
              <li>
                Brak skutecznego uiszczenia opłaty może skutkować brakiem
                aktywacji danej funkcjonalności lub brakiem możliwości dodania
                kolejnej Osoby Wskazanej.
              </li>
              <li>
                Usunięcie Osoby Wskazanej przez Użytkownika nie powoduje
                automatycznego zwrotu opłaty, z zastrzeżeniem bezwzględnie
                obowiązujących przepisów prawa.
              </li>
              <li>
                Reliance Holding może w przyszłości zmienić wysokość opłat dla
                nowych zamówień lub nowych aktywacji, z zastrzeżeniem praw
                nabytych Użytkowników.
              </li>
              <li>
                W przypadku zagubienia lub zniszczenia Karty Sukcesyjnej
                Reliance Holding może wydać duplikat Karty Sukcesyjnej na
                wniosek Użytkownika lub Osoby Wskazanej, za oddzielną opłatą
                podaną w aktualnym cenniku dostępnym w Aplikacji. Wydanie
                duplikatu powoduje unieważnienie poprzedniej Karty Sukcesyjnej.
              </li>
            </ol>

            {/* § 5 */}
            <h2>§ 5. Wymagania techniczne</h2>
            <ol className="numeric indentation--big">
              <li>
                Do korzystania z usługi „Sukcesja" niezbędne jest:
                <ol className="numeric indentation--big">
                  <li>posiadanie urządzenia z dostępem do Internetu;</li>
                  <li>
                    korzystanie z aktualnej wersji jednej z popularnych
                    przeglądarek internetowych, obsługującej bezpieczne
                    połączenie szyfrowane;
                  </li>
                  <li>
                    posiadanie aktywnego adresu e-mail przypisanego do konta
                    Użytkownika;
                  </li>
                  <li>posiadanie aktywnego konta w Aplikacji.</li>
                </ol>
              </li>
              <li>
                Dodatkowe parametry techniczne dotyczące dopuszczalnych formatów
                plików, maksymalnego rozmiaru pliku, maksymalnej liczby plików
                lub innych ograniczeń technicznych mogą być publikowane w
                Aplikacji lub w dokumentacji usługi.
              </li>
              <li>
                Reliance Holding zastrzega możliwość czasowego ograniczenia
                dostępności usługi z przyczyn technicznych, bezpieczeństwa,
                konserwacyjnych lub związanych z aktualizacją Aplikacji.
              </li>
            </ol>

            {/* § 6 */}
            <h2>
              § 6. Zasady dodawania i przechowywania Materiałów Sukcesyjnych
            </h2>
            <ol className="numeric indentation--big">
              <li>
                Użytkownik może zamieszczać w zakładce „Sukcesja" wyłącznie
                takie treści, do których posiada odpowiednie prawa lub podstawę
                do ich przechowywania i udostępniania.
              </li>
              <li>
                Użytkownik ponosi pełną odpowiedzialność za treści wprowadzane
                do zakładki „Sukcesja", w tym za ich zgodność z prawem, prawami
                osób trzecich i stanem faktycznym.
              </li>
              <li>
                Zabronione jest zamieszczanie treści:
                <ol className="numeric indentation--big">
                  <li>bezprawnych;</li>
                  <li>naruszających dobra osobiste lub prawa osób trzecich;</li>
                  <li>zawierających złośliwe oprogramowanie;</li>
                  <li>sprzecznych z celem usługi.</li>
                </ol>
              </li>
              <li>
                Użytkownik nie powinien zamieszczać w zakładce „Sukcesja" w
                szczególności:
                <ol className="numeric indentation--big">
                  <li>
                    haseł, loginów, kodów dostępu, kodów jednorazowych, PIN-ów,
                    danych uwierzytelniających lub kluczy prywatnych;
                  </li>
                  <li>
                    informacji o lokalizacji sejfów, skrytek, schowków lub
                    innych zabezpieczonych miejsc przechowywania majątku;
                  </li>
                  <li>
                    szczegółowych instrukcji umożliwiających nieuprawniony
                    dostęp do majątku, rachunków, systemów lub urządzeń;
                  </li>
                  <li>
                    danych, których ujawnienie mogłoby powodować wysokie ryzyko
                    nadużycia, kradzieży lub naruszenia bezpieczeństwa.
                  </li>
                </ol>
              </li>
              <li>
                W przypadku stwierdzenia naruszenia Regulaminu Reliance Holding
                może usunąć określone treści, zablokować do nich dostęp lub
                czasowo ograniczyć funkcjonalność usługi, po uprzednim
                poinformowaniu Użytkownika, o ile będzie to możliwe.
              </li>
            </ol>

            {/* § 7 */}
            <h2>
              § 7. Widoczność Materiałów Sukcesyjnych dla Reliance Holding
            </h2>
            <ol className="numeric indentation--big">
              <li>
                Użytkownik może zdecydować, czy określone Materiały Sukcesyjne
                mają być oznaczone jako widoczne dla upoważnionych pracowników
                lub współpracowników Reliance Holding.
              </li>
              <li>
                Jeżeli Użytkownik nie wyrazi takiej zgody, Materiały Sukcesyjne
                nie powinny być przeglądane przez personel Reliance Holding, z
                wyjątkiem sytuacji:
                <ol className="numeric indentation--big">
                  <li>
                    niezbędnych do zapewnienia bezpieczeństwa systemu, usunięcia
                    awarii lub odzyskania danych;
                  </li>
                  <li>wynikających z obowiązków prawnych;</li>
                  <li>
                    niezbędnych do ochrony praw Reliance Holding lub
                    rozpatrzenia reklamacji albo sporu.
                  </li>
                </ol>
              </li>
              <li>
                Jeżeli Użytkownik oznaczy materiały jako widoczne dla Reliance
                Holding, dostęp do nich mogą uzyskać wyłącznie osoby upoważnione
                przez Reliance Holding, w zakresie niezbędnym do realizacji celu
                wskazanego przez Użytkownika lub obsługi usługi.
              </li>
            </ol>

            {/* § 8 */}
            <h2>§ 8. Osoby Wskazane</h2>
            <ol className="numeric indentation--big">
              <li>Użytkownik może dodać jedną lub więcej Osób Wskazanych.</li>
              <li>
                Użytkownik odpowiada za prawidłowość danych kontaktowych Osób
                Wskazanych.
              </li>
              <li>
                Użytkownik może w każdej chwili edytować lub usuwać dane Osób
                Wskazanych.
              </li>
              <li>
                Dodanie Osoby Wskazanej nie oznacza automatycznego przyznania
                jej dostępu do Materiałów Sukcesyjnych przed śmiercią
                Użytkownika.
              </li>
              <li>
                Dodanie Osoby Wskazanej nie oznacza automatycznego nabycia przez
                tę osobę jakichkolwiek praw spadkowych ani innych praw
                majątkowych.
              </li>
              <li>
                Po dodaniu Osoby Wskazanej i uiszczeniu opłaty Reliance Holding
                wydaje tej osobie Kartę Sukcesyjną. Karta Sukcesyjna jest
                wysyłana na adres korespondencyjny Osoby Wskazanej wskazany
                przez Użytkownika lub bezpośrednio na adres e-mail w formie
                dokumentu elektronicznego – zgodnie z aktualnie dostępną formą
                wysyłki.
              </li>
              <li>
                Usunięcie Osoby Wskazanej przez Użytkownika powoduje
                automatyczne unieważnienie jej Karty Sukcesyjnej. Unieważniona
                Karta Sukcesyjna nie może być podstawą do złożenia Wniosku
                Dostępowego.
              </li>
              <li>
                Reliance Holding prowadzi ewidencję zmian na liście Osób
                Wskazanych wraz z oznaczeniem daty każdej zmiany. Ewidencja ta
                służy wyłącznie do weryfikacji aktualności uprawnienia w
                momencie składania Wniosku Dostępowego oraz ochrony
                uzasadnionych interesów stron.
              </li>
              <li>
                Karta Sukcesyjna jest przypisana do konkretnej Osoby Wskazanej i
                nie może być przeniesiona na inną osobę.
              </li>
            </ol>

            {/* § 9 */}
            <h2>
              § 9. Udostępnienie Materiałów Sukcesyjnych po śmierci Użytkownika
            </h2>
            <ol className="numeric indentation--big">
              <li>
                Materiały Sukcesyjne mogą zostać udostępnione wyłącznie po
                śmierci Użytkownika.
              </li>
              <li>
                Wniosek Dostępowy składany jest osobiście przez Osobę Wskazaną w
                Punkcie Obsługi Reliance Holding. Składając Wniosek Dostępowy,
                Osoba Wskazana jest zobowiązana przedłożyć:
                <ol className="numeric indentation--big">
                  <li>
                    oryginał lub urzędowo poświadczony odpis aktu zgonu
                    Użytkownika lub inny urzędowy dokument potwierdzający jego
                    śmierć;
                  </li>
                  <li>Kartę Sukcesyjną przypisaną do tej Osoby Wskazanej;</li>
                  <li>
                    ważny dokument tożsamości ze zdjęciem (dowód osobisty lub
                    paszport).
                  </li>
                </ol>
                <ol className="numeric indentation--big">
                  <li>
                    Pracownik Punktu Obsługi weryfikuje zgodność danych osoby
                    składającej wniosek z danymi Osoby Wskazanej zapisanymi w
                    systemie, aktualność Karty Sukcesyjnej oraz autentyczność
                    dokumentu potwierdzającego śmierć Użytkownika. Weryfikacja
                    następuje na podstawie aktualnego stanu listy Osób
                    Wskazanych w momencie złożenia wniosku.
                  </li>
                  <li>
                    Reliance Holding może utrwalić dane dokumentu tożsamości
                    Osoby Wskazanej w zakresie niezbędnym do potwierdzenia jej
                    tożsamości i udokumentowania przebiegu procedury
                    weryfikacyjnej. Podstawą przetwarzania tych danych jest art.
                    6 ust. 1 lit. f RODO (uzasadniony interes administratora
                    polegający na zapewnieniu bezpieczeństwa i rzetelności
                    procedury).
                  </li>
                  <li>
                    Jeżeli Osoba Wskazana nie może osobiście stawić się w
                    Punkcie Obsługi z przyczyn uzasadnionych (w szczególności
                    zamieszkanie za granicą, choroba, niepełnosprawność),
                    Reliance Holding może – według własnego uznania i po
                    potwierdzeniu okoliczności – dopuszczać alternatywne formy
                    złożenia Wniosku Dostępowego, w szczególności za
                    pośrednictwem notarialnie poświadczonego pełnomocnika lub
                    korespondencji zalecanej z załączonymi oryginalnymi
                    dokumentami. Reliance Holding nie jest zobowiązana do
                    dopuszczania trybu alternatywnego.
                  </li>
                  <li>
                    Osoba składająca Wniosek Dostępowy ponosi odpowiedzialność
                    za prawdziwość i autentyczność przedłożonych dokumentów.
                    Posługiwanie się fałszywymi dokumentami może skutkować
                    odpowiedzialnością karną na podstawie przepisów Kodeksu
                    karnego.
                  </li>
                </ol>
              </li>
              <li>
                Reliance Holding ma prawo zażądać dodatkowych dokumentów lub
                informacji, jeżeli jest to niezbędne do:
                <ol className="numeric indentation--big">
                  <li>potwierdzenia śmierci Użytkownika;</li>
                  <li>weryfikacji tożsamości osoby składającej wniosek;</li>
                  <li>potwierdzenia uprawnienia do uzyskania dostępu;</li>
                  <li>zapewnienia bezpieczeństwa udostępnienia danych.</li>
                </ol>
              </li>
              <li>
                Reliance Holding może odmówić udostępnienia Materiałów
                Sukcesyjnych lub wstrzymać procedurę, jeżeli:
                <ol className="numeric indentation--big">
                  <li>
                    przedstawione dokumenty budzą uzasadnione wątpliwości;
                  </li>
                  <li>istnieje spór co do uprawnienia osoby wnioskującej;</li>
                  <li>
                    udostępnienie mogłoby naruszać przepisy prawa lub prawa osób
                    trzecich;
                  </li>
                  <li>wniosek jest niekompletny.</li>
                </ol>
              </li>
              <li>
                W przypadku uzasadnionych wątpliwości Reliance Holding może
                uzależnić udostępnienie Materiałów Sukcesyjnych od
                przedstawienia dodatkowych dokumentów urzędowych albo
                prawomocnego rozstrzygnięcia właściwego organu.
              </li>
              <li>
                Udostępnienie Materiałów Sukcesyjnych następuje w sposób wybrany
                przez Reliance Holding jako bezpieczny i adekwatny do charakteru
                danych, w szczególności poprzez:
                <ol className="numeric indentation--big">
                  <li>przekazanie zabezpieczonej kopii elektronicznej;</li>
                  <li>przyznanie ograniczonego czasowo dostępu;</li>
                  <li>inny bezpieczny sposób uzgodniony z osobą uprawnioną.</li>
                </ol>
              </li>
              <li>
                Reliance Holding podejmuje decyzję w sprawie kompletnego Wniosku
                Dostępowego w terminie do <strong>14 dni roboczych</strong>, a w
                sprawach szczególnie skomplikowanych – do{" "}
                <strong>30 dni roboczych</strong> od dnia otrzymania kompletu
                wymaganych dokumentów.
              </li>
            </ol>

            {/* § 10 */}
            <h2>§ 10. Karta Sukcesyjna</h2>
            <ol className="numeric indentation--big">
              <li>
                Karta Sukcesyjna jest fizycznym lub elektronicznym dokumentem
                wydawanym przez Reliance Holding, potwierdzającym status Osoby
                Wskazanej i jej uprawnienie do złożenia Wniosku Dostępowego.
              </li>
              <li>
                Karta Sukcesyjna zawiera w szczególności:
                <ol className="numeric indentation--big">
                  <li>imię i nazwisko Osoby Wskazanej;</li>
                  <li>unikalny numer identyfikacyjny karty;</li>
                  <li>informację o podmiocie wydającym (Reliance Holding);</li>
                  <li>pouczenie o sposobie złożenia Wniosku Dostępowego.</li>
                </ol>
              </li>
              <li>
                Karta Sukcesyjna nie zawiera danych dostępowych do Aplikacji ani
                żadnych informacji z Materiałów Sukcesyjnych.
              </li>
              <li>
                Karta Sukcesyjna jest ważna przez czas figurowania danej Osoby
                Wskazanej na aktywnej liście Osób Wskazanych Użytkownika. Karta
                Sukcesyjna staje się nieważna z chwilą:
                <ol className="numeric indentation--big">
                  <li>usunięcia Osoby Wskazanej przez Użytkownika;</li>
                  <li>zakończenia świadczenia usługi „Sukcesja";</li>
                  <li>wydania duplikatu karty.</li>
                </ol>
              </li>
              <li>
                Osoba Wskazana zobowiązana jest do przechowywania Karty
                Sukcesyjnej w sposób uniemożliwiający dostęp osób
                nieuprawnionych. Reliance Holding nie ponosi odpowiedzialności
                za skutki utraty lub udostępnienia karty przez Osobę Wskazaną
                osobom trzecim.
              </li>
              <li>
                W przypadku zagubienia lub zniszczenia Karty Sukcesyjnej Osoba
                Wskazana lub Użytkownik powinni niezwłocznie poinformować
                Reliance Holding za pośrednictwem adresu{" "}
                <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>. Do
                czasu wydania duplikatu poprzednia karta zostaje zablokowana.
              </li>
              <li>
                Reliance Holding zastrzega sobie prawo do zmiany formy Karty
                Sukcesyjnej (fizyczna/elektroniczna) z zachowaniem co najmniej
                30-dniowego powiadomienia Użytkowników za pośrednictwem
                Aplikacji lub adresu e-mail.
              </li>
            </ol>

            {/* § 11 */}
            <h2>§ 11. Usługa Powiadomienia</h2>
            <ol className="numeric indentation--big">
              <li>
                Na zlecenie Użytkownika Reliance Holding może podjąć próbę
                poinformowania Osoby Wskazanej o procedurze ubiegania się o
                dostęp do Materiałów Sukcesyjnych po śmierci Użytkownika.
              </li>
              <li>
                Usługa Powiadomienia ma charakter informacyjny i nie jest
                równoznaczna z automatycznym przyznaniem dostępu do Materiałów
                Sukcesyjnych.
              </li>
              <li>
                Reliance Holding nie gwarantuje skutecznego doręczenia
                informacji do Osoby Wskazanej, jeżeli:
                <ol className="numeric indentation--big">
                  <li>
                    dane kontaktowe podane przez Użytkownika są nieaktualne lub
                    błędne;
                  </li>
                  <li>kontakt z Osobą Wskazaną okaże się niemożliwy;</li>
                  <li>
                    wystąpią przeszkody techniczne lub prawne niezależne od
                    Reliance Holding.
                  </li>
                </ol>
              </li>
              <li>
                Za prawidłowość danych kontaktowych Osoby Wskazanej odpowiada
                Użytkownik.
              </li>
            </ol>

            {/* § 12 */}
            <h2>§ 12. Czas trwania usługi i usunięcie danych</h2>
            <ol className="numeric indentation--big">
              <li>
                Usługa „Sukcesja" jest świadczona przez czas utrzymywania
                aktywnego konta Użytkownika w Aplikacji, chyba że odrębne
                warunki świadczenia usług stanowią inaczej.
              </li>
              <li>
                Jeżeli konto Użytkownika zostanie zdezaktywowane, zawieszone lub
                usunięte z powodu braku opłat za usługi podstawowe, Reliance
                Holding poinformuje Użytkownika o planowanym wstrzymaniu usługi
                „Sukcesja" z co najmniej 30-dniowym wyprzedzeniem, na adres
                e-mail przypisany do konta. W tym czasie Użytkownik może wznowić
                aktywność konta lub pobrać Materiały Sukcesyjne.
              </li>
              <li>
                Jeżeli Użytkownik nie wznowi aktywności konta w terminie
                wskazanym w powiadomieniu, Reliance Holding może wstrzymać
                możliwość dodawania nowych Materiałów Sukcesyjnych, zachowując
                jednocześnie dotychczas zapisane Materiały Sukcesyjne przez
                dodatkowy okres co najmniej 90 dni, umożliwiając tym samym
                złożenie Wniosku Dostępowego po śmierci Użytkownika, która
                nastąpiła przed ostatecznym usunięciem danych.
              </li>
              <li>
                Reliance Holding nie ponosi odpowiedzialności za utratę dostępu
                do Materiałów Sukcesyjnych wynikającą z zamknięcia konta przez
                Użytkownika lub usunięcia konta na jego żądanie.
              </li>
              <li>
                Użytkownik może w każdej chwili:
                <ol className="numeric indentation--big">
                  <li>usunąć wybrane Materiały Sukcesyjne;</li>
                  <li>usunąć Osobę Wskazaną;</li>
                  <li>
                    zrezygnować z usługi „Sukcesja", z zastrzeżeniem skutków
                    wynikających z odrębnych warunków korzystania z Aplikacji.
                  </li>
                </ol>
              </li>
              <li>
                Po usunięciu Materiałów Sukcesyjnych przez Użytkownika lub
                zakończeniu świadczenia usługi dane mogą być przechowywane przez
                okres wynikający z:
                <ol className="numeric indentation--big">
                  <li>obowiązków prawnych;</li>
                  <li>konieczności ochrony roszczeń;</li>
                  <li>
                    cyklu technicznego kopii zapasowych i procedur
                    bezpieczeństwa.
                  </li>
                </ol>
              </li>
              <li>
                Po upływie okresów niezbędnych, o których mowa powyżej,
                Materiały Sukcesyjne są usuwane lub anonimizowane.
              </li>
              <li>
                Jeżeli w chwili śmierci Użytkownika lista Osób Wskazanych jest
                pusta lub wszystkie Karty Sukcesyjne zostały unieważnione,
                Materiały Sukcesyjne mogą zostać udostępnione wyłącznie na
                podstawie prawomocnego orzeczenia sądu lub innego właściwego
                organu stwierdzającego uprawnienie wnioskodawcy. Reliance
                Holding nie jest zobowiązana do samodzielnego ustalania kręgu
                spadkobierców ani inicjowania procedury dostępowej.
              </li>
            </ol>

            {/* § 13 */}
            <h2>§ 13. Reklamacje</h2>
            <ol className="numeric indentation--big">
              <li>
                Użytkownik może składać reklamacje dotyczące usługi „Sukcesja":
                <ol className="numeric indentation--big">
                  <li>
                    drogą elektroniczną na adres:{" "}
                    <a href="mailto:biuro@reliance.pro">
                      <strong>biuro@reliance.pro</strong>
                    </a>
                    ; lub
                  </li>
                  <li>pisemnie na adres siedziby Reliance Holding.</li>
                </ol>
              </li>
              <li>
                Reklamacja powinna zawierać co najmniej:
                <ol className="numeric indentation--big">
                  <li>dane Użytkownika;</li>
                  <li>opis zgłaszanych zastrzeżeń;</li>
                  <li>wskazanie żądania Użytkownika.</li>
                </ol>
              </li>
              <li>
                Reliance Holding rozpatruje reklamację w terminie{" "}
                <strong>14 dni</strong> od dnia jej otrzymania, a jeśli
                rozpatrzenie reklamacji w tym terminie nie będzie możliwe –
                informuje Użytkownika o przyczynach opóźnienia i przewidywanym
                terminie odpowiedzi.
              </li>
            </ol>

            {/* § 14 */}
            <h2>§ 14. Prawo odstąpienia od umowy przez konsumenta</h2>
            <ol className="numeric indentation--big">
              <li>
                Jeżeli Użytkownik jest konsumentem, ma prawo odstąpić od umowy
                dotyczącej odpłatnej aktywacji usługi „Sukcesja" lub odpłatnego
                dodania Osoby Wskazanej w terminie 14 dni od dnia zawarcia
                umowy, bez podawania przyczyny, z zastrzeżeniem wyjątków
                przewidzianych przepisami prawa.
              </li>
              <li>
                Jeżeli Użytkownik zażąda rozpoczęcia świadczenia usługi przed
                upływem terminu do odstąpienia, a następnie skorzysta z prawa
                odstąpienia, może zostać zobowiązany do zapłaty kwoty
                proporcjonalnej do zakresu świadczeń spełnionych do chwili
                odstąpienia, o ile wynika to z przepisów prawa.
              </li>
              <li>
                Jeżeli w danym przypadku spełnione zostaną przesłanki ustawowe
                powodujące utratę prawa odstąpienia, Reliance Holding
                poinformuje o tym Użytkownika przed zawarciem umowy lub przed
                rozpoczęciem świadczenia.
              </li>
              <li>
                Szczegółowe zasady odstąpienia od umowy oraz wzór formularza
                odstąpienia mogą zostać udostępnione Użytkownikowi na trwałym
                nośniku lub w ramach głównego regulaminu Aplikacji.
              </li>
            </ol>

            {/* § 15 */}
            <h2>§ 15. Odpowiedzialność</h2>
            <ol className="numeric indentation--big">
              <li>
                Reliance Holding odpowiada za świadczenie usługi „Sukcesja"
                zgodnie z obowiązującymi przepisami prawa.
              </li>
              <li>
                Reliance Holding nie ponosi odpowiedzialności za:
                <ol className="numeric indentation--big">
                  <li>
                    treść, aktualność, kompletność lub prawdziwość Materiałów
                    Sukcesyjnych zamieszczonych przez Użytkownika;
                  </li>
                  <li>
                    brak możliwości kontaktu z Osobą Wskazaną z przyczyn
                    niezależnych od Reliance Holding;
                  </li>
                  <li>
                    skutki wynikające z podania przez Użytkownika
                    nieprawdziwych, niepełnych lub nieaktualnych danych;
                  </li>
                  <li>
                    skutki prawne wynikające z wykorzystania przez Użytkownika
                    usługi „Sukcesja" jako jedynego instrumentu planowania
                    sukcesyjnego.
                  </li>
                </ol>
              </li>
              <li>
                Reliance Holding nie odpowiada za brak możliwości udostępnienia
                Materiałów Sukcesyjnych, jeżeli wynika on z braku wymaganych
                dokumentów, sporu prawnego, braku możliwości potwierdzenia
                uprawnienia albo obowiązujących przepisów prawa.
              </li>
              <li>
                Ograniczenia odpowiedzialności określone w Regulaminie nie
                wyłączają ani nie ograniczają praw konsumenta wynikających z
                bezwzględnie obowiązujących przepisów prawa.
              </li>
            </ol>

            {/* § 16 */}
            <h2>§ 16. Dane osobowe</h2>
            <ol className="numeric indentation--big">
              <li>
                Administratorem danych osobowych przetwarzanych w związku z
                realizacją usługi „Sukcesja" jest Reliance Holding.
              </li>
              <li>
                Szczegółowe zasady przetwarzania danych osobowych, w tym danych
                Użytkownika, Osób Wskazanych oraz osób składających Wniosek
                Dostępowy, określa Polityka Prywatności.
              </li>
              <li>
                Użytkownik zobowiązuje się przekazywać do usługi wyłącznie takie
                dane osób trzecich, których podanie jest niezbędne do realizacji
                celu usługi i dla których posiada odpowiednią podstawę.
              </li>
              <li>
                W ramach procedury weryfikacyjnej w Punkcie Obsługi Reliance
                Holding przetwarza dane osobowe Osoby Wskazanej obejmujące dane
                identyfikacyjne z dokumentu tożsamości (imię i nazwisko, numer
                dokumentu, datę ważności) w celu potwierdzenia tożsamości i
                udokumentowania przebiegu procedury. Podstawą przetwarzania jest
                art. 6 ust. 1 lit. f RODO.
              </li>
              <li>
                Dane osobowe Osób Wskazanych (imię, nazwisko, dane kontaktowe)
                są przetwarzane na podstawie art. 6 ust. 1 lit. f RODO, tj. w
                celu realizacji usługi zgodnie z dyspozycją Użytkownika.
                Użytkownik, dodając Osobę Wskazaną, oświadcza, że poinformował
                tę osobę o przetwarzaniu jej danych przez Reliance Holding w
                związku z usługą „Sukcesja" lub że posiada inną podstawę do
                przekazania tych danych.
              </li>
            </ol>

            {/* § 17 */}
            <h2>§ 17. Zmiany Regulaminu</h2>
            <ol className="numeric indentation--big">
              <li>
                Reliance Holding może zmienić niniejszy Regulamin z ważnych
                przyczyn, w szczególności z powodu:
                <ol className="numeric indentation--big">
                  <li>zmian przepisów prawa;</li>
                  <li>
                    zmian funkcjonalności Aplikacji lub usługi „Sukcesja";
                  </li>
                  <li>zmian technologicznych lub organizacyjnych;</li>
                  <li>konieczności doprecyzowania postanowień Regulaminu.</li>
                </ol>
              </li>
              <li>
                O zmianie Regulaminu Użytkownik zostanie poinformowany z
                odpowiednim wyprzedzeniem poprzez Aplikację lub wiadomość
                e-mail.
              </li>
              <li>
                Zmiany Regulaminu nie naruszają praw nabytych Użytkowników przed
                dniem wejścia w życie zmian, chyba że obowiązujące przepisy
                prawa stanowią inaczej.
              </li>
            </ol>

            {/* § 18 */}
            <h2>§ 18. Postanowienia końcowe</h2>
            <ol className="numeric indentation--big">
              <li>
                Regulamin jest udostępniany Użytkownikowi nieodpłatnie w sposób
                umożliwiający jego pozyskanie, odtwarzanie i utrwalanie.
              </li>
              <li>Prawem właściwym dla Regulaminu jest prawo polskie.</li>
              <li>
                W przypadku Użytkowników będących konsumentami wszelkie
                postanowienia Regulaminu stosuje się z uwzględnieniem
                bezwzględnie obowiązujących przepisów prawa konsumenckiego.
              </li>
              <li>Regulamin wchodzi w życie z dniem 26.05.2026.</li>
            </ol>

            {/* Załącznik nr 1 */}
            <h2>Załącznik nr 1 – Formularz odstąpienia od umowy</h2>
            <div className="indentation--big">
              <p>
                <strong>Adresat:</strong> Reliance Holding sp. z o.o., al. 29
                Listopada 39E/U3, 31-425 Kraków, e-mail:{" "}
                <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>
              </p>
              <p>
                Ja, niżej podpisany niniejszym informuję o odstąpieniu od umowy
                dotyczącej następującej usługi:
              </p>
              <ul>
                <li>
                  Nazwa usługi: <strong>„Sukcesja"</strong>
                </li>
                <li>Data zawarcia umowy: ………………………………………………………………….</li>
                <li>Imię i nazwisko konsumenta: …………………………………………………………...</li>
                <li>Adres konsumenta: ……………………………………………………………………...</li>
                <li>Adres e-mail: ……………………………………………………………………………</li>
              </ul>
              <div className="withdrawal-form-signature">
                <p>Data: ……………………………</p>
                <p>Podpis: …………………………………..</p>
              </div>
            </div>
          </div>
        </p>
      </>
    </LoginWrapper>
  );
};

export default TermsOfServicePage;
